import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import WordBankSelect from './WordBankSelect';
import { addToObject, removeFromObject } from '../../utils/immutable';
import { letters } from '../../utils/constants';

class WordBankSelectGroup extends Component {
  constructor(props) {
    super(props);
    props.setPartialCreditValidator(this.partialCreditValidator);
    props.setReviewSheet(this.renderReviewChunk);
  }

  isQuestionReadyForSubmit = (data, payload) => {
    const minOptions =
      typeof data.minOptions !== 'undefined' ? data.minOptions : 1;
    return (
      !minOptions ||
      (minOptions === 1 && payload) ||
      (payload instanceof Array && payload.length >= minOptions)
    );
  };

  handleClick = (question, option) => {
    const { input, onInput, setSubmitStatus } = this.props;
    const payload =
      option === null
        ? removeFromObject(input, question)
        : addToObject(input, question, option);
    onInput(payload);

    if (this.isGroup()) {
      setSubmitStatus(
        this.props.data.every(question => {
          return this.isQuestionReadyForSubmit(
            question,
            payload[`${question.beforeSpace}${question.afterSpace}`]
          );
        })
      );
    } else {
      setSubmitStatus(
        this.isQuestionReadyForSubmit(this.props.data, payload[question])
      );
    }
  };

  isGroup = () => {
    return Array.isArray(this.props.data);
  };

  getSelectedOptions = question => {
    const { input } = this.props;
    if (input && question in input) {
      return input[question];
    }
    return null;
  };

  partialCreditValidator = () => {
    if (this.isGroup()) {
      console.warn(
        'Partial credit not implemented for Word Bank Select question groups!'
      );
    }
    return false;
  };

  renderReviewChunk = () => {
    // Because of the design requirements for the review answer sheet, each TEI is going to be displayed differently.
    // Because of this, generating the review sheet JSX in each TEI, and then sending that down the line, allows us
    // to customize how we're building each review segment by TEI type.
    const { data, correctInput } = this.props;
    let answerString = '';

    if (this.isGroup()) {
      // AFAIK, we'll never really deal with groups of questions in the challenge/review section
      // If we do, then we'll need to turn
    } else {
      data.options.forEach((option, index) => {
        if (
          option.label === correctInput[`${data.beforeSpace}${data.afterSpace}`]
        ) {
          answerString = letters[index];
        }
      });
      return (
        <div>
          <p className="review-question">
            {data.beforeSpace}
            <span className="wbs__question__space" />
            {data.afterSpace}
          </p>
          {data.options.map((option, index) => (
            <p key={index} className="review-option">
              {letters[index]}. {option.label}
            </p>
          ))}
          <p className="review-correct">Correct Answer: {answerString}</p>
        </div>
      );
    }
  };

  render() {
    const { data, correctInput } = this.props;

    const renderWordBankSelect = data => (
      <WordBankSelect
        data={data}
        onClick={this.handleClick}
        input={this.getSelectedOptions(`${data.beforeSpace}${data.afterSpace}`)}
        correctInput={correctInput[`${data.beforeSpace}${data.afterSpace}`]}
        validationResult={this.props.validationResult}
        isFinalAttempt={this.props.isFinalAttempt}
      />
    );

    if (this.isGroup()) {
      return data.map((question, i) => (
        <Fragment key={i}>{renderWordBankSelect(question)}</Fragment>
      ));
    } else {
      return renderWordBankSelect(data);
    }
  }
}

WordBankSelectGroup.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired
};

export default WordBankSelectGroup;



// WEBPACK FOOTER //
// ../core/src/components/WordBankSelect/WordBankSelectGroup.js